export enum WorkLevelStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const WorkLevelStatusOptions = [
  {
    label: "Active",
    value: WorkLevelStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: WorkLevelStatus.INACTIVE,
  },
];
